module.exports = __webpack_public_path__ + "img/yuhuin.b86ad37e.png";